var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkirt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9417 2C4.82638 2 3.92224 2.9052 3.92224 4.02182V5.28545H20.0779V4.02182C20.0779 2.9052 19.1738 2 18.0585 2H5.9417Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.199 6.80182H3.80103L2.0213 17.9381C1.94579 18.4106 2.07298 18.893 2.37154 19.2667C3.31082 20.4422 4.86321 20.9381 6.30894 20.5245L6.54495 20.457C6.6017 20.4408 6.65887 20.4271 6.7163 20.4159L7.20548 13.0696C7.2333 12.6518 7.59416 12.3356 8.01147 12.3635C8.42879 12.3914 8.74453 12.7526 8.71671 13.1704L8.21511 20.7032C8.22506 20.7096 8.23495 20.7161 8.24481 20.7227L8.62633 20.9773C10.6693 22.3409 13.3307 22.3409 15.3737 20.9773L15.7552 20.7227C15.765 20.7161 15.7749 20.7096 15.7849 20.7032L15.2833 13.1704C15.2555 12.7526 15.5712 12.3914 15.9885 12.3635C16.4058 12.3356 16.7667 12.6518 16.7945 13.0696L17.2837 20.4159C17.3411 20.4271 17.3983 20.4408 17.455 20.457L17.6911 20.5245C19.1368 20.9381 20.6892 20.4422 21.6285 19.2667C21.927 18.893 22.0542 18.4106 21.9787 17.9381L20.199 6.80182Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkirt1);
export default __webpack_public_path__ + "static/media/skirt-1.10de5966323b12efed63c304aceaadc3.svg";
export { ForwardRef as ReactComponent };